<template>
    <div class="exam-page-container select-exam">
      <!-- 主体内容 -->
      <div class="exam-content">
        <!-- 左侧信息栏 -->
        <div class="sidebar">
          <!-- 1. 考生信息 -->
          <el-card class="info-card" v-if="userInfo">
            <el-row>
                <el-col :span="24">
                    <div class="info-item">考生姓名：<strong>{{ userInfo.name }}</strong></div>
                    <!-- <div class="info-item">座位号：<strong>{{ userInfo.seatNumber ? userInfo.seatNumber : "TODO"}}</strong></div> -->
                    <div class="info-item">身份证号：{{ userInfo.idCard }}</div>
                    <div class="info-item">准考证号：{{ userInfo.uname ? userInfo.uname : "TODO"}}</div>
                </el-col>
            </el-row>
          </el-card>

          <!-- 2. 做题状态 -->
          <el-card class="question-status">
            <div class="status">
              <span style="color: red;">标记: {{ flaggedQuestions.length }} 题</span>
              <span style="color: #48a0f8">已答: {{ Object.keys(answers).length }} 题 </span>
              <span style="color: black;">未答: {{ totalQuestions.length - Object.keys(answers).length }} 题</span>
            </div>
          </el-card>
  
          <!-- 3. 题目导航 -->
          <el-card class="question-nav">
            <div class="question_type" v-if="judgmentNum>0"> 判断题 (共{{ judgmentNum }}题 合计{{ judgmentQuestions.reduce((accumulator, current) => {return accumulator + current.score},0) }}分) </div>
            <el-row class="question-grid" :gutter="10">
              <el-col v-for="(question, index) in judgmentQuestions" :key="index" :span="4" style="padding: 5px;">
                <el-button
                  size="small"
                  class="question-btn"
                  :class="{ 'active-btn':currentQuestionId == index,answered: answers[question.qid] }"
                  @click="changeCurrentQuestion('判断题', index)"
                >
                  {{ index + 1 }}
                  <el-icon v-if="flaggedQuestions.includes(question.qid)" style="color: red;"><Flag /></el-icon>
                </el-button>
              </el-col>
            </el-row>
            <div class="question_type" v-if="singleChoiceNum>0"> 单选题 (共{{ singleChoiceNum }}题 合计{{ singleChoiceQuestions.reduce((accumulator, current) => {return accumulator + current.score},0) }}分) </div>
            <el-row class="question-grid" :gutter="10">
              <el-col v-for="(question, index) in singleChoiceQuestions" :key="index" :span="4" style="padding: 5px;">
                <el-button
                  size="small"
                  class="question-btn"
                  :class="{ 'active-btn':currentQuestionId == index + judgmentNum,answered: answers[question.qid] }"
                  @click="changeCurrentQuestion('单选题', index)" 
                >
                  {{ index + 1 }}
                  <el-icon v-if="flaggedQuestions.includes(question.qid)" style="color: red;"><Flag /></el-icon>
                </el-button>
              </el-col>
            </el-row>
            <div class="question_type" v-if="multipleChoiceNum>0"> 多选题 (共{{ multipleChoiceNum }}题 合计{{ multipleChoiceQuestions.reduce((accumulator, current) => {return accumulator + current.score},0) }}分) </div>
            <el-row class="question-grid" :gutter="10">
              <el-col v-for="(question, index) in multipleChoiceQuestions" :key="index" :span="4" style="padding: 5px;">
                <el-button
                  size="small"
                  class="question-btn"
                  :class="{ 'active-btn':currentQuestionId == index + judgmentNum + multipleChoiceNum,answered: answers[question.qid] }"
                  @click="changeCurrentQuestion('多选题', index)"
                >
                  {{ index + 1 }}
                  <el-icon v-if="flaggedQuestions.includes(question.qid)" style="color: red;"><Flag /></el-icon>
                </el-button>
              </el-col>
            </el-row>
            <div class="question_type" v-if="simplifiedNum>0"> 简答题 (共{{ simplifiedNum }}题 合计{{ simplifiedQuestions.reduce((accumulator, current) => {return accumulator + current.score},0) }}分) </div>
            <el-row class="question-grid" :gutter="10">
              <el-col v-for="(question, index) in simplifiedQuestions" :key="index" :span="4" style="padding: 5px;">
                <el-button
                  size="small"
                  class="question-btn"
                  :class="{ 'active-btn':currentQuestionId == index + judgmentNum + multipleChoiceNum + simplifiedNum,answered: answers[question.qid] }"
                  @click="changeCurrentQuestion('简答题', index)"
                >
                  {{ index + 1 }}
                  <el-icon v-if="flaggedQuestions.includes(question.qid)" style="color: red;"><Flag /></el-icon>
                </el-button>
              </el-col>
            </el-row>
          </el-card>


          <!-- 4. 提交按钮 -->
          <div class="submit-container">
            <el-button type="primary" class="submit-btn" @click="isAnswerCompleted()">交卷</el-button>
          </div>
        </div>

        <!-- 未答题交卷确认弹框 -->
        <el-dialog
          v-model="notCompleteDialog"
          title="未答题交卷确认"
          width="40%"
          align-center
        >
          <span>您还有{{ totalQuestions.length - Object.keys(answers).length }}道题未完成，确认交卷？</span>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="notCompleteDialog = false">取消并继续答题</el-button>
              <el-button type="primary" @click="notCompleteDialog = false; firstConfirmDialog = true">
                确认交卷
              </el-button>
            </span>
          </template>
        </el-dialog>

        <!-- 第一次交卷确认弹框 -->
        <el-dialog
          v-model="firstConfirmDialog"
          title="交卷确认第1次"
          width="40%"
          align-center
        >
          <span>如果您还想检查试卷，请点击”取消井返回”</span>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="firstConfirmDialog = false">取消并返回</el-button>
              <el-button type="primary" @click="firstConfirmDialog = false; secondConfirmDialog = true">
                确认交卷
              </el-button>
            </span>
          </template>
        </el-dialog>

        <!-- 第二次交卷确认弹框 -->
        <el-dialog
          v-model="secondConfirmDialog"
          title="交卷确认第2次"
          width="40%"
          align-center
        >
          <span>如果您还想检查试卷，请点击”取消井返回”</span>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="secondConfirmDialog = false">取消并返回</el-button>
              <el-button type="primary" @click="secondConfirmDialog = false; thirdConfirmDialog = true">
                确认交卷
              </el-button>
            </span>
          </template>
        </el-dialog>

        <!-- 第三次交卷确认弹框 -->
        <el-dialog
          v-model="thirdConfirmDialog"
          title="交卷确认第3次"
          width="40%"
          align-center
        >
          <span>如果您还想检查试卷，请点击”取消井返回”</span>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="thirdConfirmDialog = false">取消并返回</el-button>
              <el-button type="primary" @click="submitExam()" :loading="submitLoading" >
                确认交卷
              </el-button>
            </span>
          </template>
        </el-dialog>
  
        <!-- 右侧试题内容 -->
        <div class="main">
          <div class="question-area" v-if="totalQuestions[currentQuestionId] && totalQuestions[currentQuestionId].type === '判断题'">
            <span>判断题 (共{{ judgmentNum }}题) </span>
            <div class="question-box">
              <div class="question">
                <strong>{{ currentQuestionId + 1 }}. {{ totalQuestions[currentQuestionId].questionText }}</strong>
                <span class="score">[{{ totalQuestions[currentQuestionId].score }}分]</span>
                <el-icon @click.stop="toggleFlag(totalQuestions[currentQuestionId].qid)" :style="{ color: flaggedQuestions.includes(totalQuestions[currentQuestionId].qid) ? 'red' : '' }"><Flag /></el-icon>

              </div>
              <el-radio-group v-model="answers[totalQuestions[currentQuestionId].qid]">
                <el-radio :value="'正确'">正确</el-radio>
                <el-radio :value="'错误'">错误</el-radio>
              </el-radio-group>
            </div>
            <div class="question-controls">
              <el-button class="prev-btn" @click="prevQuestion">上一题</el-button>
              <el-button class="next-btn" type="primary" @click="nextQuestion">下一题</el-button>
            </div>
          </div>
          <div class="question-area" v-if="totalQuestions[currentQuestionId] && totalQuestions[currentQuestionId].type === '单选题'">
            <span>单选题 (共{{ singleChoiceNum }}题) </span>
            <div class="question-box">
              <div class="question">
                <strong>{{ currentQuestionId - judgmentNum + 1 }}. {{ totalQuestions[currentQuestionId].questionText }}</strong>
                <span class="score">[{{ totalQuestions[currentQuestionId].score }}分]</span>
                <el-icon @click.stop="toggleFlag(totalQuestions[currentQuestionId].qid)" :style="{ color: flaggedQuestions.includes(totalQuestions[currentQuestionId].qid) ? 'red' : '' }"><Flag /></el-icon>
              </div>
              <el-radio-group v-model="answers[totalQuestions[currentQuestionId].qid]">
                <el-radio :value="option.id" v-for="option in totalQuestions[currentQuestionId].options" :key="option.id">{{ option.optionText }}</el-radio>
              </el-radio-group>
            </div>
            <div class="question-controls">
              <el-button class="prev-btn" @click="prevQuestion">上一题</el-button>
              <el-button class="next-btn" type="primary" @click="nextQuestion">下一题</el-button>
            </div>
          </div>
          <div class="question-area" v-if="totalQuestions[currentQuestionId] && totalQuestions[currentQuestionId].type === '多选题'">
            <span>多选题 (共{{ multipleChoiceNum }}题) </span>
            <div class="question-box">
              <div class="question">
                <strong>{{ currentQuestionId - judgmentNum - singleChoiceNum + 1 }}. {{ totalQuestions[currentQuestionId].questionText }}</strong>
                <span class="score">[{{ totalQuestions[currentQuestionId].score }}分]</span>
                <el-icon @click.stop="toggleFlag(totalQuestions[currentQuestionId].qid)" :style="{ color: flaggedQuestions.includes(totalQuestions[currentQuestionId].qid) ? 'red' : '' }"><Flag /></el-icon>
              </div>
              <el-checkbox-group v-model="answers[totalQuestions[currentQuestionId].qid]">
                <el-checkbox :value="option.id" v-for="option in totalQuestions[currentQuestionId].options" :key="option.id">{{ option.optionText }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="question-controls">
              <el-button class="prev-btn" @click="prevQuestion">上一题</el-button>
              <el-button class="next-btn" type="primary" @click="nextQuestion">下一题</el-button>
            </div>
          </div>
          <div class="question-area" v-if="totalQuestions[currentQuestionId] && totalQuestions[currentQuestionId].type === '简答题'">
            <span>简答题 (共{{ simplifiedNum }}题) </span>
            <div class="question-box">
              <div class="question">
                <strong>{{ currentQuestionId - judgmentNum - singleChoiceNum - multipleChoiceNum + 1 }}. {{ totalQuestions[currentQuestionId].questionText }}</strong>
                <span class="score">[{{ totalQuestions[currentQuestionId].score }}分]</span>
                <el-icon @click.stop="toggleFlag(totalQuestions[currentQuestionId].qid)" :style="{ color: flaggedQuestions.includes(totalQuestions[currentQuestionId].qid) ? 'red' : '' }"><Flag /></el-icon>
              </div>
              <el-input v-model="answers[totalQuestions[currentQuestionId].qid]" type="textarea" />
            </div>
            <div class="question-controls">
              <el-button class="prev-btn" @click="prevQuestion">上一题</el-button>
              <el-button class="next-btn" type="primary" @click="nextQuestion">下一题</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { ElButton, ElRadioGroup, ElRadio, ElRow, ElCol, ElCard, ElCheckboxGroup, ElCheckbox, ElIcon, ElInput, ElDialog, ElMessage } from "element-plus";
import { Flag } from '@element-plus/icons-vue';
import "@/pages/ExamineePage/components/ExamPage/css/SelectExam.css";
import api from '@/utils/api';
import { mapGetters, mapActions } from 'vuex';


export default {
  name: "ExamPage",
  components: {
    ElButton,
    ElRadioGroup,
    ElRadio,
    ElRow,
    ElCol,
    ElCard,
    ElCheckboxGroup,
    ElCheckbox,
    ElIcon,
    Flag,
    ElInput,
    ElDialog
  },
  data() {
    // eslint-disable-next-line no-debugger
    return {
      answers: {}, // 存储用户的答案
      userInfo: null, // 添加 userInfo 数据
      judgmentQuestions: [], // 判断题
      judgmentNum: 0, // 判断题数量
      singleChoiceQuestions: [], // 单选题
      singleChoiceNum: 0, // 单选题数量
      multipleChoiceQuestions: [], // 多选题
      multipleChoiceNum: 0, // 多选题数量
      simplifiedQuestions: [], // 简答题
      simplifiedNum: 0, // 简答题数量
      currentQuestionId: 0, // 当前题目的索引
      flaggedQuestions: [], // 存储标记的题目
      totalQuestions: [], // 总题目列表
      notCompleteDialog: false, // 未完成对话框
      firstConfirmDialog: false, // 第一次确认对话框
      secondConfirmDialog: false, // 第二次确认对话框
      thirdConfirmDialog: false, // 第三次确认对话框
      submitIntervalId: null, // 定时器ID
      durationIntervalId: null, // 定时器ID
      selectPaper: null, // 存储试卷
      submitLoading: false, // 提交按钮加载状态
      startTime: null, // 考试开始时间
      endTime: null, // 考试结束时间
      tempSaveIntervalId: null
    };
  },
  computed: {
    ...mapGetters(['getJoinedExam']),
    joined_exam() {
      return this.getJoinedExam;
    }
  },
  mounted() {
    const storedUserInfo = localStorage.getItem('userInfo');
    const storedAnswers = localStorage.getItem('answers');
    const storedFlaggedQuestions = localStorage.getItem('flaggedTheoreticalQuestions');
    const storedCurrentQuestionId = localStorage.getItem('currentQuestionId');
    
    if (storedUserInfo) {
      this.userInfo = JSON.parse(storedUserInfo);
    }

    fetch("fakeApi/getSelectPaper.json").then(response => {
        return response.json();
      }).then(response => {
        console.log('获取题目信息成功:', response.data);
        this.extractQuestions(response.data || []);
        this.selectPaper = response.data;
      }).catch(error => {
        console.error('获取题目信息失败:', error);
      });

    // api.getSelectPaper(this.userInfo.uid, this.joined_exam.examid).then(response => {
    //   console.log('获取题目信息成功:', response.data);
    //   this.extractQuestions(response.data || []);
    //   this.selectPaper = response.data;
    // }).catch(error => {
    //   console.error('获取题目信息失败:', error);
    // });

    if (storedAnswers) {
      this.answers = JSON.parse(storedAnswers);
    }
    
    if (storedFlaggedQuestions) {
      this.flaggedQuestions = JSON.parse(storedFlaggedQuestions);
    }
    
    if (storedCurrentQuestionId > 0) {
      this.currentQuestionId = storedCurrentQuestionId;
    }

    this.updateTimes();

    // this.submitIntervalId = setInterval(this.checkTimeAndSubmit, 1000);
    this.durationIntervalId = setInterval(this.checkTimeAndDuration, 1000);
    // this.tempSaveIntervalId = setInterval(this.tempSubmitSelect, 60000); // 每隔1分钟保存一次答案
  },
  methods: {
    ...mapActions(['updateJoinedExam']),
    tempSubmitSelect() {
      // 每隔1分钟保存一次答案
      api.tempSubmitSelect(this.userInfo.uid, this.joined_exam.examid, JSON.stringify(this.answers)); // 调用保存答案的API
    },
    extractQuestions(questions) {
      questions.forEach(question => {
        if (question.questionSelect.type === '判断题') {
          this.judgmentQuestions.push({ ...question.questionSelect, score: question.score });
        } else if (question.questionSelect.type === '单选题') {
          this.singleChoiceQuestions.push({ ...question.questionSelect, score: question.score });
        } else if (question.questionSelect.type === '多选题') {
          this.multipleChoiceQuestions.push({ ...question.questionSelect, score: question.score });
        } else if (question.questionSelect.type === '简答题') {
          this.simplifiedQuestions.push({ ...question.questionSelect, score: question.score });
        }
      });
      this.totalQuestions = [...this.judgmentQuestions, ...this.singleChoiceQuestions, ...this.multipleChoiceQuestions, ...this.simplifiedQuestions];
      
      this.judgmentNum = this.judgmentQuestions.length;
      this.singleChoiceNum = this.singleChoiceQuestions.length;
      this.multipleChoiceNum = this.multipleChoiceQuestions.length;
      this.simplifiedNum = this.simplifiedQuestions.length;
    },
    prevQuestion() {
      if(this.currentQuestionId > 0){
        this.currentQuestionId--;
        localStorage.setItem('currentQuestionId', this.currentQuestionId);
      }
    },
    nextQuestion() {
      if(this.currentQuestionId < this.totalQuestions.length - 1){
        this.currentQuestionId++;
        localStorage.setItem('currentQuestionId', this.currentQuestionId);
      }
    },
    toggleFlag(qid) {
      const index = this.flaggedQuestions.indexOf(qid);
      if (index === -1) {
        this.flaggedQuestions.push(qid);
      } else {
        this.flaggedQuestions.splice(index, 1);
      }
      localStorage.setItem('flaggedTheoreticalQuestions', JSON.stringify(this.flaggedQuestions));
    },
    submitExam() {
      this.submitLoading = "true";
      console.log('answers:', this.answers);
      
      // const updatedAnswers = this.selectPaper.map(question => {
      //   const answer = this.answers[question.questionSelect.qid];
      //   if (question.questionSelect.type === '判断题' || question.questionSelect.type === '单选题' || question.questionSelect.type === '简答题') {
      //     question.selectedAnswer = answer;
      //   } else if (question.questionSelect.type === '多选题') {
      //     question.selectedAnswer = answer && answer.join('|');
      //   }
      //   return question;
      // });
      // const selectionPaperDTO = {
      //   uid: this.userInfo.uid,
      //   examid: this.joined_exam.examid,
      //   resultQuestionSelects: updatedAnswers
      // };

      ElMessage.success('答案提交成功');
      this.thirdConfirmDialog = false;
      localStorage.removeItem('joined_exam');
      localStorage.removeItem('answers');
      localStorage.removeItem('currentQuestionId');
      localStorage.removeItem('flaggedTheoreticalQuestions');
      this.$router.push('/examinee-home');
      sessionStorage.setItem(`submit_exam:${this.joined_exam.examid}`, 'true');
      // api.submitSelect(selectionPaperDTO)
      //   .then(response => {
      //     console.log('答案已提交:', response);
      //     ElMessage.success('答案提交成功');
      //     this.thirdConfirmDialog = false;
      //     localStorage.removeItem('joined_exam');
      //     localStorage.removeItem('answers');
      //     localStorage.removeItem('currentQuestionId');
      //     localStorage.removeItem('flaggedTheoreticalQuestions');
      //     this.$router.push('/examinee-home');
      //   })
      //   .catch(error => {
      //     console.error('提交答案失败:', error);
      //     this.thirdConfirmDialog = false
      //     ElMessage.error('答案提交失败');
      //   });
      this.submitLoading = "false";
    },
    changeCurrentQuestion(type, index) {
      if (type == '判断题') {
        this.currentQuestionId = index;
        localStorage.setItem('currentQuestionId', JSON.stringify(this.currentQuestionId));
      } else if (type == '单选题') {
        this.currentQuestionId = index + this.judgmentNum;
        localStorage.setItem('currentQuestionId', JSON.stringify(this.currentQuestionId));
      } else if (type == '多选题') {
        this.currentQuestionId = index + this.judgmentNum + this.singleChoiceNum;
        localStorage.setItem('currentQuestionId', JSON.stringify(this.currentQuestionId));
      } else if (type == '简答题') {
        this.currentQuestionId = index + this.judgmentNum + this.singleChoiceNum + this.multipleChoiceNum;
        localStorage.setItem('currentQuestionId', JSON.stringify(this.currentQuestionId));
      }
    },
    isAnswerCompleted(){
      if(this.totalQuestions.length == Object.keys(this.answers).length) {
        this.firstConfirmDialog = true;
      }else {
        this.notCompleteDialog = true;
      }
    },
    // 检查时间并执行操作
    checkTimeAndDuration() {
      if (this.joined_exam) {
        const start = new Date(this.startTime).getTime();
        const current = new Date().getTime();
        
        // 计算当前时间和开始时间的差值（以毫秒为单位）
        const duration = current - start;
        
        // 45分钟对应的毫秒数
        const fortyFiveMinutesInMs = 45 * 60 * 1000;
        if (duration > fortyFiveMinutesInMs) {
          return false; // 超过45分钟，允许交卷
        } else {
          return true; // 未超过45分钟，不允许交卷
        }
      }else{
        return false;
      }
    },
    updateTimes() {
      const examAddTime = this.joined_exam.examAddTime || 0; // 默认加时时间为0
      const examineeAddTime = this.joined_exam.examineeAddTime || 0; // 默认加时时间为0
      this.startTime = new Date(this.joined_exam.examStartTime);
      this.endTime = new Date(this.joined_exam.examEndTime);
      
      // 根据 addTime 更新结束时间
      this.endTime.setMinutes(this.endTime.getMinutes() + examAddTime + examineeAddTime);
    },
    fetchExamineeInfo() {
      const uid = this.userInfo ? this.userInfo.uid : null;
      api.getExamineeExams(uid).then(response => {
        console.log('获取考试信息成功:', response.data);
        const exams = response.data;
        const exam = exams.find(item => item.examid === this.joined_exam.examid);
        localStorage.setItem('examineeInfo', JSON.stringify(exams));
        this.updateJoinedExam(exam);
        ElMessage.success('刷新成功');
      }).catch(error => {
        console.error('获取考生信息失败:', error);
        ElMessage.error('刷新失败');
      });
    },
    // 检查时间并执行操作
    async checkTimeAndSubmit() {
      if(this.endTime) {
        const end = new Date(this.endTime).getTime();
        const current = new Date().getTime();
        const remainingTime = end - current;
        // 判断是否距离结束还有20秒
        if (remainingTime <= 21 * 1000 && remainingTime >= 20 * 1000 && remainingTime > 0) {
          
          await this.fetchExamineeInfo(); // 调用获取考生信息的方法
        }
        if (current >= end) {
          clearInterval(this.durationIntervalId);
          clearInterval(this.submitIntervalId);
          clearInterval(this.tempSaveIntervalId);
          await this.submitExam(); // 假设这是你的提交答案函数
        }
      }
    }
  },
  watch: {
    answers: {
      handler(newAnswers) {
        localStorage.setItem('answers', JSON.stringify(newAnswers));
      },
      deep: true
    },
    joined_exam() {
      this.updateTimes()
    }
  },
  // 组件卸载时清除定时器
  onUnmounted() {
    clearInterval(this.durationIntervalId);
    clearInterval(this.submitIntervalId);
    clearInterval(this.tempSaveIntervalId);
  }
};
</script>